import React, { useState, createContext } from "react";

export const AccountContext = createContext();

export const AccountProvider = (props) => {
  const [userInfo, setUserInfo] = useState({
    isLoggedIn: false,
    avatarUrl: "default url",
    username: "please login",
    email: "",
    name: "name",
    profile: {},
  });

  return (
    <AccountContext.Provider value={[userInfo, setUserInfo]}>
      {props.children}
    </AccountContext.Provider>
  );
};
